/**
 * Redact secrets from orchestration console payloads before clipboard/export.
 */

const SECRET_KEY_PATTERN =
  /^(userToken|geminiApiKey|geminiAccessToken|access_token|refresh_token|api[_-]?key|authorization|password|secret|service_role|private_key|token)$/i;

const JWT_PATTERN = /^eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;
const GOOGLE_API_KEY_PATTERN = /^AIza[0-9A-Za-z_-]{20,}$/;

function redactString(value: string): string {
  if (JWT_PATTERN.test(value)) return "[REDACTED_JWT]";
  if (GOOGLE_API_KEY_PATTERN.test(value)) return "[REDACTED_API_KEY]";
  return value;
}

export function redactSecretsDeep(value: unknown): unknown {
  if (value == null) return value;
  if (typeof value === "string") return redactString(value);
  if (typeof value !== "object") return value;
  if (Array.isArray(value)) return value.map(redactSecretsDeep);

  const out: Record<string, unknown> = {};
  for (const [key, child] of Object.entries(value as Record<string, unknown>)) {
    if (SECRET_KEY_PATTERN.test(key)) {
      out[key] = "[REDACTED]";
      continue;
    }
    out[key] = redactSecretsDeep(child);
  }
  return out;
}
